import container from "../../libs/container/container";

const amdHowToSellFaqModule = (function () {
    const name = 'how-to-sell__faq-module';

    const view = container.getBaseView(name);

    view.privateVars = {
        faq: {
            current: null,
            loading: false
        }
    }

    view.startup = function () {

    };

    view.bind = function () {
        const faqItems = document.querySelectorAll(view.publicVars.cssId.faqItemBarCls);

        faqItems.forEach((item) => {
            item.addEventListener('click', function() {
                const id = container.getData(item, 'id');

                if(!view.privateVars.faq.loading) {
                    view.privateVars.faq.loading = true;
                    view.methods.actionToggleFaqItem(id);
                }
            });
        });
    };

    view.methods = {
        actionToggleFaqItem: (id) => {

            function closeContent(contentElement, element, expandedCls, callback) {
                contentElement.style.height = contentElement.offsetHeight + 'px';

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        contentElement.classList.add(view.publicVars.cssId.faqItemContentTransitionCls.substring(1));
                        contentElement.style.cssText = 'height: 0; opacity: 0; transform: scale(0.9);';
                    });
                });

                contentElement.addEventListener('transitionend', function (event) {
                    contentElement.removeAttribute('style');
                    contentElement.classList.remove(view.publicVars.cssId.faqItemContentTransitionCls.substring(1));
                    callback && callback();
                }, { once: true});


                // $(contentElement).transit({height: 0, opacity: 0, scale: 0.9}, 300, function () {
                //     contentElement.removeAttribute('style');
                //     callback && callback();
                // });

                element.classList.remove(expandedCls);
            }

            const currentElement = document.querySelector('#' + view.publicVars.cssId.faqItemCls.substring(1) + id);
            const expandedCls = view.publicVars.cssId.faqItemExpandedCls.substring(1);

            const contentElement = currentElement.querySelector(view.publicVars.cssId.faqItemContentCls);

            if(currentElement.classList.contains(expandedCls)) {

                container.msg(name, 'faq item close ' + id);

                view.privateVars.faq.current = null;

                closeContent(contentElement, currentElement, expandedCls, () => {
                    view.privateVars.faq.loading = false;
                });
            } else {

                container.msg(name, 'faq item open ' + id);

                if(view.privateVars.faq.current !== null) {
                    const prevElement = document.querySelector('#' + view.publicVars.cssId.faqItemCls.substring(1)
                        + view.privateVars.faq.current);

                    const prevContentElement = prevElement.querySelector(view.publicVars.cssId.faqItemContentCls);

                    closeContent(prevContentElement, prevElement, expandedCls);
                }

                view.privateVars.faq.current = id;

                contentElement.style.height = 'auto';
                const height = contentElement.offsetHeight + 'px';

                contentElement.style.cssText = 'height: 0px; opacity: 0; transform: scale(0.9);';

                contentElement.addEventListener('transitionend', function (event) {
                    contentElement.style.cssText = 'height: auto;opacity: 1;';
                    view.privateVars.faq.loading = false;
                    contentElement.classList.remove(view.publicVars.cssId.faqItemContentTransitionCls.substring(1));
                }, { once: true});

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        contentElement.classList.add(view.publicVars.cssId.faqItemContentTransitionCls.substring(1));
                        contentElement.style.cssText = 'height: ' + height + '; opacity: 1; transform: scale(1);';
                    });
                });

                // $(contentElement).transit({height: height, opacity: 1, scale: 1}, 300, function () {
                //     contentElement.style.cssText = 'height: auto;opacity: 1;';
                //     view.privateVars.faq.loading = false;
                // });

                currentElement.classList.add(expandedCls);


            }
        }
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdHowToSellFaqModule;